import { beYou } from "./beYou";
import { beYou2 } from "./beYou2";
import { beYou3 } from "./beYou3";
import { beYou4 } from "./beYou4";
import casque from "./casque";
import caviarFlat from "./caviarFlat";
import celestialFlat from "./celestialFlat";
import champagne from "./champagne";
import chateauDeFresnesFlat from "./chateauDeFresnesFlat";
import companyFlat from "./companyFlat";
import domusFlat from "./domusFlat";
import dragonFlat from "./dragonFlat";
import explorerFlat from "./explorerFlat";
import floralArtFlat from "./floralArtFlat";
import goldenWoodFlat from "./goldenWoodFlat";
import grappeFlat from "./grappeFlat";
import hairStyleFlat from "./hairStyleFlat";
import imagePlusFlat from "./imagePlusFlat";
import kiwanoFlat from "./kiwanoFlat";
import etacCerf from "./etacCerf";
import etacLion from "./etacLion";
import etacOngle from "./etacOngle";
import lagerBeerFlat from "./lagerBeerFlat";
import luciaFlat from "./luciaFlat";
import magnoliaFlat from "./magnoliaFlat";
import medardBox from "./medardBox";
import { mediflex } from "./mediflex";
import saintJulienFlat from "./saintJulienFlat";
import vodkaFlat from "./vodkaFlat";
import deerWhisky from "./whiskyDeer";
import whiteBloomFlat from "./whiteBloomFlat";
import victoryFlat from "./victory";
import boulangerieFlat from "./boulangerie";
import smileFlat from "./smileFlat";
import { ProductContent } from "../repositories/ProductRepository";

export default function StaticPackagingRepository(
  name?: string
): ProductContent {
  switch (name) {
    case "Mediflex":
      return mediflex;
    case "BeYou":
      return beYou;
    case "beYou2":
      return beYou2;
    case "beYou3":
      return beYou3;
    case "beYou4":
      return beYou4;
    case "WhiskyDeer":
      return deerWhisky;
    case "Dragon":
      return dragonFlat;
    case "GoldenWood":
      return goldenWoodFlat;
    case "ChateauDeFresnes":
      return { ...chateauDeFresnesFlat, type: "bottleLabel" };
    case "Lucia":
      return luciaFlat;
    case "Domus":
      return domusFlat;
    case "Company":
      return companyFlat;
    case "FloralArt":
      return floralArtFlat;
    case "Caviar":
      return { ...caviarFlat, type: "bottleLabel" };
    case "Magnolia":
      return magnoliaFlat;
    case "ImagePlus":
      return imagePlusFlat;
    case "Celestial":
      return celestialFlat;
    case "Explorer":
      return { ...explorerFlat, type: "bottleLabel" };
    case "HairStyle":
      return hairStyleFlat;
    case "Kiwano":
      return { ...kiwanoFlat, type: "bottleLabel" };
    case "etacCerf":
      return etacCerf;
    case "etacLion":
      return etacLion;
    case "etacOngle":
      return etacOngle;
    case "LagerBeer":
      return { ...lagerBeerFlat, type: "bottleLabel" };
    case "SaintJulien":
      return { ...saintJulienFlat, type: "bottleLabel" };
    case "Grappe":
      return { ...grappeFlat, type: "bottleLabel" };
    case "WhiteBloom":
      return { ...whiteBloomFlat, type: "bottleLabel" };
    case "Vodka":
      return { ...vodkaFlat, type: "bottleLabel" };
    case "medardBox":
      return medardBox;
    case "champagne":
      return champagne;
    case "casque":
      return casque;
    case "victory":
      return victoryFlat;
    case "smile":
      return smileFlat;
    case "boulangerie":
      return boulangerieFlat;
    default:
      return mediflex;
  }
}
